import { SET_CUSTOM_FILTER_SEARCH_MYFLEET } from './types';

const reducers = (state: any = {}, action: any) => {
  switch (action.type) {
    case SET_CUSTOM_FILTER_SEARCH_MYFLEET: {
      let customFilterMyfleet = state?.customFilterMyfleet ?? {};
      customFilterMyfleet = { ...customFilterMyfleet, ...action.customFilterValues };
      return {
        ...state,
        customFilterMyfleet,
      };
    }
    default:
      return state;
  }
};

export default reducers;
